export enum EFetchReloadKey {
	listAccountBuyer = 'listAccountBuyer',
	listAccountTeam = 'listAccountTeam',
	listRevenueAgency = 'listRevenueAgency',
	allParallelList = 'allParallelList',
	allList = 'allList',
}
